function getPodiumLevels(building, podiumProps) {
	const podiumLevels = [];
	const buildingLevels = building.data.levels.sort((a, b) => a.floorWorldBottom - b.floorWorldBottom);
	for (let i = 0; i < podiumProps.count; i++) podiumLevels.push(buildingLevels[podiumProps.start + i]);
	return podiumLevels;
}
export { getPodiumLevels };

//# sourceMappingURL=index225.js.map